<template>
  <div v-if="profile" class="d-flex align-center cursor-pointer profile-button">
    <avatar :avatar="profile.profile?.userAvatar" :literal="literal" size="S" online />
    <div v-if="showName" :class="{ short }" class="name">
      <b class="paragraph-s">{{ profile.profile?.name }} {{ profile.profile?.lastName }}</b>
      <div class="paragraph-xs text-ordinary">{{ profile.email }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { useDisplay } from 'vuetify';
import Avatar from '@/core/components/common/Avatar.vue';
import { useAuthStore } from '@/parts/auth/store/auth';

const props = defineProps<{
  short?: boolean;
}>();

const display = useDisplay();
const { profile } = useAuthStore();

const literal = toRef(() =>
  profile.value && profile.value.profile?.name ? profile.value.profile?.name.slice(0, 2) : '',
);

const showName = toRef(() => !props.short || display.lgAndUp.value);
</script>

<style scoped lang="scss">
.profile-button {
  white-space: nowrap;
}

.name {
  margin-left: 12px;

  @include md-and-down {
    &.short {
      margin-left: 0;
    }
  }
}
</style>
